import { initializeApp } from "firebase/app";
import { getFirestore, doc, updateDoc, arrayUnion } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "CloudComputing.firebaseapp.com",
  projectId: "cloudcomputing-b38cb",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);